<template>
  <div class="div">
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="总览" name="1"> </el-tab-pane>
      <el-tab-pane label="设备状态统计" name="2"> </el-tab-pane>
    </el-tabs>
    <div class="w100" v-if="activeName === '1'">
      <div class="dom-card" v-loading="DeviceFaultYearsLoading">
        <div class="dom-card-title df jub">
          <span>设备全周期故障分布</span>
          <div>
            <el-select
              v-model="DeviceFaultYearsSelect"
              placeholder="请选择"
              style="width: 200px; margin-right: 5px"
            >
              <el-option label="按楼栋分布" value="bui"> </el-option>
              <el-option label="按专业设备分布" value="dev"> </el-option>
            </el-select>
            <span class="hint-text">单位：（次）</span>
          </div>
        </div>
        <div class="w100 df">
          <div style="width: 70%">
            <EchartsDom
              type="bar2"
              :data="DeviceFaultYears.tlist || []"
              width="100%"
              yAxisName="故障次数"
              :isStack="false"
              :grid="{
                left: 60,
                top: 60,
                right: 30,
                bottom: 40,
              }"
              legendTop="10px"
              height="240px"
              v-if="DeviceFaultYearsSelect === 'bui'"
            >
            </EchartsDom>
            <EchartsDom
              type="bar2"
              :data="DeviceFaultYears.blist || []"
              width="100%"
              yAxisName="故障次数"
              :isStack="false"
              :grid="{
                left: 60,
                top: 60,
                right: 40,
                bottom: 40,
              }"
              legendTop="10px"
              height="240px"
              v-if="DeviceFaultYearsSelect === 'dev'"
            >
            </EchartsDom>
          </div>

          <div style="width: 30%">
            <EchartsDom
              type="pie"
              :data="DeviceFaultYears?.bpiechartList || []"
              width="100%"
              height="240px"
              legendPosition="left"
              legendLeft="10%"
              style="border-left: 1px solid #dcdfe6"
            />
          </div>
        </div>
      </div>

      <div
        class="dom-card"
        style="margin-top: 10px"
        v-loading="DeviceFaultTypeYearLoading"
      >
        <div class="dom-card-title df jub">
          <span>设备寿命期故障统计</span>
          <span class="hint-text">单位：（次）</span>
        </div>
        <div class="df w100 fww" style="padding-top: 10px">
          <EchartsDom
            type="bar2"
            v-for="item in DeviceFaultTypeYear || []"
            :key="item.name"
            :title="item.name"
            :data="item.value || []"
            width="33%"
            yAxisName="故障次数"
            :isStack="false"
            height="200px"
          >
          </EchartsDom>
        </div>
      </div>
    </div>
    <div class="w100" v-if="activeName === '2'">
      <div class="div-top">
        <div>
          <span class="label">时间选项:</span>
          <el-radio-group v-model="searchData.TimeType" @change="timeTypeChange">
            <el-radio-button label="YearMonth">年月</el-radio-button>
            <el-radio-button label="Year">年份</el-radio-button>
          </el-radio-group>
          <div v-if="searchData.TimeType === 'Year'" style="display: inline-block">
            <span class="label">选择年份:</span>

            <span style="display: inline-block">
              <el-date-picker
                v-model="searchData.StartTimeYear"
                type="year"
                :picker-options="startYearOptions"
                placeholder="选择年份"
                value-format="yyyy"
                style="width: 150px; text-align: center"
                :clearable="false"
                @change="getDataList"
              >
              </el-date-picker>
              <span class="separator">至</span>
              <el-date-picker
                v-model="searchData.EndTimeYear"
                type="year"
                placeholder="结束年份"
                :picker-options="endYearOptions"
                value-format="yyyy"
                :clearable="false"
                @change="getDataList"
                style="width: 150px; text-align: center"
              >
              </el-date-picker>
            </span>
          </div>
          <div v-if="searchData.TimeType === 'YearMonth'" style="display: inline-block">
            <span class="label">选择年月:</span>
            <el-date-picker
              v-model="searchData.searchYear"
              type="monthrange"
              :clearable="false"
              range-separator="至"
              value-format="yyyyMM"
              start-placeholder="开始月份"
              end-placeholder="结束月份"
              @change="getDataList"
            >
            </el-date-picker>
          </div>
        </div>
        <div class="search-item" v-loading="buildingLoading">
          <div class="label">选择楼栋分类:</div>
          <el-checkbox-group v-model="searchData.Buildings" @change="BuildingsListChange">
            <el-checkbox
              v-for="item in BuildingsList"
              :key="item.Id"
              :label="item.Id"
              :disabled="item.disabled"
              >{{ item.Name }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
        <div class="search-item" v-loading="deviceTypeLoading">
          <div class="label">选择设备分类:</div>
          <el-checkbox-group
            v-model="searchData.DeviceTypes"
            @change="DeviceTypesListChange"
          >
            <el-checkbox
              v-for="item in DeviceTypesList"
              :key="item.Id"
              :label="item.Id"
              :disabled="item.disabled"
              >{{ item.DicName }}</el-checkbox
            >
          </el-checkbox-group>
        </div>
      </div>
      <div class="df" style="gap: 10px">
        <div
          class="dom-card"
          style="margin-top: 10px; width: 50%"
          v-loading="DeviceStopPowerLoading"
        >
          <div class="dom-card-title df jub">
            <span>设备停机统计</span>
            <div>
              <el-radio-group v-model="DeviceStopPowerDataType">
                <el-radio-button label="bar"
                  ><i class="el-icon-s-data"></i> 趋势</el-radio-button
                >
                <el-radio-button label="pie">
                  <i class="el-icon-pie-chart"></i> 分布</el-radio-button
                >
              </el-radio-group>
              <span class="hint-text">单位：（次）</span>
            </div>
          </div>
          <EchartsDom
            type="bar2"
            :data="DeviceStopPower.blist || []"
            width="100%"
            yAxisName="停机次数"
            :isStack="false"
            :grid="{
              left: 60,
              top: 60,
              right: 40,
              bottom: 40,
            }"
            legendTop="10px"
            height="240px"
            v-if="DeviceStopPowerDataType === 'bar'"
          >
          </EchartsDom>
          <EchartsDom
            type="pie"
            :data="DeviceStopPower?.piechartList || []"
            width="100%"
            height="240px"
            :grid="{
              left: 60,
              top: 60,
              right: 40,
              bottom: 40,
            }"
            legendTop="10px"
            legendPosition="left"
            legendLeft="10%"
            v-if="DeviceStopPowerDataType === 'pie'"
          >
          </EchartsDom>
        </div>
        <div
          class="dom-card"
          style="margin-top: 10px; width: 50%"
          v-loading="DeviceStopPowerHourTypeLoading && DeviceStopPowerCountTypeLoading"
        >
          <div class="dom-card-title df jub">
            <span v-if="DeviceStopPowerTypeSelect === 'Hour'"
              >设备{{
                searchData.TimeType === "YearMonth" ? "月份" : "年度"
              }}停机时长统计</span
            >
            <span v-if="DeviceStopPowerTypeSelect === 'Count'"
              >设备{{
                searchData.TimeType === "YearMonth" ? "月份" : "年度"
              }}停机次数统计</span
            >
            <div>
              <el-select
                v-model="DeviceStopPowerTypeSelect"
                placeholder="请选择"
                style="width: 200px; margin-right: 5px"
              >
                <el-option label="按停机时长" value="Hour"> </el-option>
                <el-option label="按停机次数" value="Count"> </el-option>
              </el-select>
              <el-select
                v-model="DeviceStopPowerDataTypeSelect"
                placeholder="请选择"
                style="width: 200px; margin-right: 5px"
              >
                <el-option label="按楼栋分布" value="bui"> </el-option>
                <el-option label="按专业设备分布" value="dev"> </el-option>
              </el-select>
              <el-radio-group v-model="DeviceStopPowerType">
                <el-radio-button label="bar"
                  ><i class="el-icon-s-data"></i> 趋势</el-radio-button
                >
                <el-radio-button label="pie">
                  <i class="el-icon-pie-chart"></i> 分布</el-radio-button
                >
              </el-radio-group>
              <span class="hint-text" v-if="DeviceStopPowerTypeSelect === 'Hour'"
                >单位：（小时）</span
              >
              <span class="hint-text" v-if="DeviceStopPowerTypeSelect === 'Count'"
                >单位：（次）</span
              >
            </div>
          </div>

          <!-- //停机时长 -->
          <div
            style="width: 100%"
            v-if="DeviceStopPowerTypeSelect === 'Hour'"
            v-loading="DeviceStopPowerHourTypeLoading"
          >
            <EchartsDom
              type="bar2"
              :data="DeviceStopPowerHourType.blist || []"
              width="100%"
              yAxisName="停机时长"
              :isStack="false"
              :grid="{
                left: 60,
                top: 60,
                right: 40,
                bottom: 40,
              }"
              legendTop="10px"
              height="240px"
              v-if="
                DeviceStopPowerDataTypeSelect === 'bui' && DeviceStopPowerType === 'bar'
              "
            >
            </EchartsDom>
            <EchartsDom
              type="bar2"
              :data="DeviceStopPowerHourType.tlist || []"
              width="100%"
              yAxisName="停机时长"
              :isStack="false"
              :grid="{
                left: 60,
                top: 60,
                right: 40,
                bottom: 40,
              }"
              legendTop="10px"
              height="240px"
              v-if="
                DeviceStopPowerDataTypeSelect === 'dev' && DeviceStopPowerType === 'bar'
              "
            >
            </EchartsDom>
            <EchartsDom
              type="pie"
              :data="DeviceStopPowerHourType?.bpiechartList || []"
              width="100%"
              height="240px"
              legendPosition="left"
              legendLeft="10%"
              v-if="
                DeviceStopPowerDataTypeSelect === 'bui' && DeviceStopPowerType === 'pie'
              "
            >
            </EchartsDom>
            <EchartsDom
              type="pie"
              :data="DeviceStopPowerHourType?.tpiechartList || []"
              width="100%"
              height="240px"
              legendPosition="left"
              legendLeft="10%"
              v-if="
                DeviceStopPowerDataTypeSelect === 'dev' && DeviceStopPowerType === 'pie'
              "
            >
            </EchartsDom>
          </div>
          <!-- 停机次数 -->
          <div
            style="width: 100%"
            v-if="DeviceStopPowerTypeSelect === 'Count'"
            v-loading="DeviceStopPowerCountTypeLoading"
          >
            <EchartsDom
              type="bar2"
              :data="DeviceStopPowerCountType.blist || []"
              width="100%"
              yAxisName="停机次数"
              :grid="{
                left: 60,
                top: 60,
                right: 40,
                bottom: 40,
              }"
              legendTop="10px"
              :isStack="false"
              height="240px"
              v-if="
                DeviceStopPowerDataTypeSelect === 'bui' && DeviceStopPowerType === 'bar'
              "
            >
            </EchartsDom>
            <EchartsDom
              type="bar2"
              :data="DeviceStopPowerCountType.tlist || []"
              width="100%"
              yAxisName="停机次数"
              :grid="{
                left: 60,
                top: 60,
                right: 40,
                bottom: 40,
              }"
              legendTop="10px"
              :isStack="false"
              height="240px"
              v-if="
                DeviceStopPowerDataTypeSelect === 'dev' && DeviceStopPowerType === 'bar'
              "
            >
            </EchartsDom>
            <EchartsDom
              type="pie"
              :data="DeviceStopPowerCountType?.bpiechartList || []"
              width="100%"
              height="240px"
              legendPosition="left"
              legendLeft="10%"
              v-if="
                DeviceStopPowerDataTypeSelect === 'bui' && DeviceStopPowerType === 'pie'
              "
            >
            </EchartsDom>
            <EchartsDom
              type="pie"
              :data="DeviceStopPowerCountType?.tpiechartList || []"
              width="100%"
              height="240px"
              legendPosition="left"
              legendLeft="10%"
              v-if="
                DeviceStopPowerDataTypeSelect === 'dev' && DeviceStopPowerType === 'pie'
              "
            >
            </EchartsDom>
          </div>
        </div>
      </div>
      <div class="df" style="gap: 10px">
        <div
          class="dom-card"
          style="margin-top: 10px; width: 50%"
          v-loading="DeviceFaultLoading"
        >
          <div class="dom-card-title df jub">
            <span>设备故障统计</span>
            <div>
              <el-radio-group v-model="DeviceFaultDataType">
                <el-radio-button label="bar"
                  ><i class="el-icon-s-data"></i> 趋势</el-radio-button
                >
                <el-radio-button label="pie">
                  <i class="el-icon-pie-chart"></i> 分布</el-radio-button
                >
              </el-radio-group>
              <span class="hint-text">单位：（次）</span>
            </div>
          </div>
          <div class="class-name"></div>
          <EchartsDom
            type="bar2"
            :data="DeviceFault?.blist || []"
            width="100%"
            :grid="{
              left: 60,
              top: 60,
              right: 40,
              bottom: 40,
            }"
            legendTop="10px"
            :isStack="false"
            height="240px"
            v-if="DeviceFaultDataType === 'bar'"
          >
          </EchartsDom>
          <EchartsDom
            type="pie"
            :data="DeviceFault?.piechartList || []"
            width="100%"
            height="240px"
            legendPosition="left"
            :isStack="false"
            legendLeft="10%"
            v-if="DeviceFaultDataType === 'pie'"
          >
          </EchartsDom>
        </div>
        <div
          class="dom-card"
          style="margin-top: 10px; width: 50%"
          v-loading="DeviceFaultYearMonthLoading && DeviceFaultYearMonthHourLoading"
        >
          <div class="dom-card-title df jub">
            <span v-if="DeviceFaultYearMonthTypeSelect === 'Hour'"
              >设备{{
                searchData.TimeType === "YearMonth" ? "月份" : "年度"
              }}故障时长统计</span
            >
            <span v-if="DeviceFaultYearMonthTypeSelect === 'Count'"
              >设备{{
                searchData.TimeType === "YearMonth" ? "月份" : "年度"
              }}故障次数统计</span
            >
            <div>
              <el-select
                v-model="DeviceFaultYearMonthTypeSelect"
                placeholder="请选择"
                style="width: 200px; margin-right: 5px"
              >
                <el-option label="按故障时长" value="Hour"> </el-option>
                <el-option label="按故障次数" value="Count"> </el-option>
              </el-select>
              <el-select
                v-model="DeviceFaultYearMonthSelect"
                placeholder="请选择"
                style="width: 200px; margin-right: 5px"
              >
                <el-option label="按楼栋分布" value="bui"> </el-option>
                <el-option label="按专业设备分布" value="dev"> </el-option>
              </el-select>
              <el-radio-group v-model="DeviceFaultYearMonthDataType">
                <el-radio-button label="bar"
                  ><i class="el-icon-s-data"></i> 趋势</el-radio-button
                >
                <el-radio-button label="pie">
                  <i class="el-icon-pie-chart"></i> 分布</el-radio-button
                >
              </el-radio-group>
              <span class="hint-text" v-if="DeviceFaultYearMonthTypeSelect === 'Hour'"
                >单位：（小时）</span
              >
              <span class="hint-text" v-if="DeviceFaultYearMonthTypeSelect === 'Count'"
                >单位：（次）</span
              >
            </div>
          </div>
          <div
            v-if="DeviceFaultYearMonthTypeSelect === 'Hour'"
            v-loading="DeviceFaultYearMonthHourLoading"
          >
            <EchartsDom
              type="bar2"
              :data="DeviceFaultYearMonthHour.tlist || []"
              width="100%"
              yAxisName="故障时长"
              :isStack="false"
              :grid="{
                left: 60,
                top: 60,
                right: 40,
                bottom: 40,
              }"
              legendTop="10px"
              height="240px"
              v-if="
                DeviceFaultYearMonthSelect === 'bui' &&
                DeviceFaultYearMonthDataType === 'bar'
              "
            >
            </EchartsDom>
            <EchartsDom
              type="bar2"
              :grid="{
                left: 60,
                top: 60,
                right: 40,
                bottom: 40,
              }"
              legendTop="10px"
              :data="DeviceFaultYearMonthHour.blist || []"
              width="100%"
              yAxisName="故障时长"
              :isStack="false"
              height="240px"
              v-if="
                DeviceFaultYearMonthSelect === 'dev' &&
                DeviceFaultYearMonthDataType === 'bar'
              "
            >
            </EchartsDom>
            <EchartsDom
              type="pie"
              :data="DeviceFaultYearMonthHour?.tpiechartList || []"
              width="100%"
              height="240px"
              legendPosition="left"
              legendLeft="10%"
              v-if="
                DeviceFaultYearMonthSelect === 'bui' &&
                DeviceFaultYearMonthDataType === 'pie'
              "
            >
            </EchartsDom>
            <EchartsDom
              type="pie"
              :data="DeviceFaultYearMonthHour?.bpiechartList || []"
              width="100%"
              height="240px"
              legendPosition="left"
              legendLeft="10%"
              v-if="
                DeviceFaultYearMonthSelect === 'dev' &&
                DeviceFaultYearMonthDataType === 'pie'
              "
            >
            </EchartsDom>
          </div>
          <div
            v-if="DeviceFaultYearMonthTypeSelect === 'Count'"
            v-loading="DeviceFaultYearMonthLoading"
          >
            <EchartsDom
              type="bar2"
              :data="DeviceFaultYearMonth.tlist || []"
              width="100%"
              yAxisName="故障次数"
              :isStack="false"
              height="240px"
              :grid="{
                left: 60,
                top: 60,
                right: 40,
                bottom: 40,
              }"
              legendTop="10px"
              v-if="
                DeviceFaultYearMonthSelect === 'bui' &&
                DeviceFaultYearMonthDataType === 'bar'
              "
            >
            </EchartsDom>
            <EchartsDom
              type="bar2"
              :data="DeviceFaultYearMonth.blist || []"
              width="100%"
              yAxisName="故障次数"
              :isStack="false"
              :grid="{
                left: 60,
                top: 60,
                right: 40,
                bottom: 40,
              }"
              legendTop="10px"
              height="240px"
              v-if="
                DeviceFaultYearMonthSelect === 'dev' &&
                DeviceFaultYearMonthDataType === 'bar'
              "
            >
            </EchartsDom>
            <EchartsDom
              type="pie"
              :data="DeviceFaultYearMonth?.tpiechartList || []"
              width="100%"
              height="240px"
              legendPosition="left"
              legendLeft="10%"
              v-if="
                DeviceFaultYearMonthSelect === 'bui' &&
                DeviceFaultYearMonthDataType === 'pie'
              "
            >
            </EchartsDom>
            <EchartsDom
              type="pie"
              :data="DeviceFaultYearMonth?.bpiechartList || []"
              width="100%"
              height="240px"
              legendPosition="left"
              legendLeft="10%"
              v-if="
                DeviceFaultYearMonthSelect === 'dev' &&
                DeviceFaultYearMonthDataType === 'pie'
              "
            >
            </EchartsDom>
          </div>
        </div>
      </div>

      <!-- <div
        class="dom-card"
        style="margin-top: 10px"
        v-loading="DeviceStopPowerCountTypeLoading"
      >
        <div class="dom-card-title df jub">
          <span
            >设备{{
              searchData.TimeType === "YearMonth" ? "月份" : "年度"
            }}停机次数统计</span
          >
          <span class="hint-text">单位：（次）</span>
        </div>
        <div class="card-selet" style="height: 40px; margin-top: 10px; text-align: right">
          <el-select
            v-model="DeviceStopPowerCountTypeSelect"
            placeholder="请选择"
            style="width: 200px;margin-right: 5px;"
          >
            <el-option label="按楼栋分布" value="bui"> </el-option>
            <el-option label="按专业设备分布" value="dev"> </el-option>
          </el-select>
        </div>
        <EchartsDom
          type="bar2"
          :data="DeviceStopPowerCountType.blist || []"
          width="100%"
          yAxisName="停机次数"
          :isStack="false"
          height="300px"
          v-if="DeviceStopPowerCountTypeSelect === 'bui'"
        >
        </EchartsDom>
        <EchartsDom
          type="bar2"
          :data="DeviceStopPowerCountType.tlist || []"
          width="100%"
          yAxisName="停机次数"
          :isStack="false"
          height="300px"
          v-if="DeviceStopPowerCountTypeSelect === 'dev'"
        >
        </EchartsDom>
      </div> -->

      <div class="dom-card" style="margin-top: 10px" v-loading="DeviceFaultTypeLoading">
        <div class="dom-card-title df jub">
          <span>设备故障类型统计</span>
          <div class="class-name">
            <el-select
              v-model="DeviceFaultTypeSelect"
              placeholder="请选择"
              style="width: 200px; margin-right: 5px"
            >
              <el-option label="按楼栋分布" value="bui"> </el-option>
              <el-option label="按专业设备分布" value="dev"> </el-option>
            </el-select>
            <span class="hint-text">单位：（次）</span>
          </div>
        </div>

        <EchartsDom
          type="bar2"
          :data="DeviceFaultType.blist || []"
          width="100%"
          yAxisName="故障次数"
          :grid="{
            left: 60,
            top: 60,
            right: 40,
            bottom: 40,
          }"
          legendTop="10px"
          :isStack="false"
          height="240px"
          v-if="DeviceFaultTypeSelect === 'bui'"
        >
        </EchartsDom>
        <EchartsDom
          type="bar2"
          :data="DeviceFaultType.tlist || []"
          width="100%"
          :grid="{
            left: 60,
            top: 60,
            right: 40,
            bottom: 40,
          }"
          legendTop="10px"
          yAxisName="故障次数"
          :isStack="false"
          height="240px"
          v-if="DeviceFaultTypeSelect === 'dev'"
        >
        </EchartsDom>
      </div>
    </div>
    <div style="height: 20px"></div>
  </div>
</template>
<script>
import moment from "moment";

import EchartsDom from "@/components/EchartsDom/EchartsDom.vue";
export default {
  data() {
    return {
      activeName: "1",
      searchData: {
        SortType: "Building",
        TimeType: "YearMonth",

        StartTime: "",
        EndTime: "",
        DeviceTypes: [],
        Buildings: [],
        searchYear: [],
        StartTimeYear: "",
        EndTimeYear: "",
      },
      loading: false,
      deviceTypeLoading: false,
      buildingLoading: false,
      debouncedGetDataList: null,
      BuildingsList: [],
      DeviceTypesList: [],
      workOrderList: {},
      workOrderTimeList: [],
      workOrderTimeList2: [],
      workOrderAreaList: [],
      workOrderDeviceList: [],

      spanArr: [], // 用于存储 blist 合并行信息
      spanArrTlist: [], // 用于存储 tlist 合并行信息

      DeviceDistributionLoading: false,
      DeviceDistribution: [],
      DeviceScrappingType: "bui",
      DeviceScrappingLoading: false,
      DeviceScrapping: {},
      DeviceValue: {},
      DeviceValueType: "bui",
      DeviceValueLoading: false,
      DeviceLifespan: {},
      DeviceLifespanType: "bui",
      DeviceLifespanLoading: false,
      //有参数条件的
      DeviceFault: {},
      DeviceFaultDataType: "bar",
      DeviceFaultLoading: false,
      DeviceStopPower: {},
      DeviceStopPowerDataType: "bar",
      DeviceStopPowerLoading: false,

      //停机时长/次数
      DeviceStopPowerHourType: {},
      DeviceStopPowerHourTypeLoading: false,
      // DeviceStopPowerHourTypeSelect: "bui",
      DeviceStopPowerTypeSelect: "Hour",
      DeviceStopPowerDataTypeSelect: "bui",
      DeviceStopPowerType: "bar",
      DeviceStopPowerCountType: {},
      // DeviceStopPowerCountTypeSelect: "bui",
      DeviceStopPowerCountTypeLoading: false,
      //故障时长/次数
      DeviceFaultYearMonth: {},
      DeviceFaultYearMonthLoading: false,
      DeviceFaultYearMonthTypeSelect: "Hour",
      DeviceFaultYearMonthSelect: "bui",
      DeviceFaultYearMonthDataType: "bar",
      DeviceFaultYearMonthHour: {},
      DeviceFaultYearMonthHourLoading: false,

      DeviceFaultYears: {},
      DeviceFaultYearsSelect: "bui",
      DeviceFaultYearsLoading: false,
      DeviceFaultType: {},
      DeviceFaultTypeSelect: "bui",
      DeviceFaultTypeLoading: false,
      DeviceFaultTypeYear: [],
      DeviceFaultTypeYearLoading: false,
    };
  },
  props: {},
  components: { EchartsDom },
  methods: {
    // 各区设备故障情况---故障次数
    async getDeviceFault() {
      this.DeviceFaultLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceFaultAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceFaultLoading = false;
          if (res.Success) {
            this.DeviceFault = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //各区设备故障情况---停机分布
    async getDeviceStopPower() {
      this.DeviceStopPowerLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceStopPowerAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceStopPowerLoading = false;
          if (res.Success) {
            this.DeviceStopPower = res.Data || [];
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //各区设备各月停机统计-按楼和按分类 统计-时长统计
    async getDeviceStopPowerHourType() {
      this.DeviceStopPowerHourTypeLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceStopPowerHourTypeAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceStopPowerHourTypeLoading = false;
          if (res.Success) {
            this.DeviceStopPowerHourType = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //各区设备各月停机统计-按楼和按分类 统计-次数统计
    async getDeviceStopPowerCountType() {
      this.DeviceStopPowerCountTypeLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceStopPowerCountTypeAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceStopPowerCountTypeLoading = false;
          if (res.Success) {
            this.DeviceStopPowerCountType = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //设备故障分析-故障频次 按楼 按分类
    async getDeviceFaultYearMonth() {
      this.DeviceFaultYearMonthLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceFaultYearMonthAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceFaultYearMonthLoading = false;
          if (res.Success) {
            this.DeviceFaultYearMonth = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //设备故障分析-故障时长 按楼 按分类
    async getDeviceFaultYearMonthHour() {
      this.DeviceFaultYearMonthHourLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceFaultYearMonthHourAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceFaultYearMonthHourLoading = false;
          if (res.Success) {
            this.DeviceFaultYearMonthHour = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //设备故障分析-故障类类分布
    async getDeviceFaultType() {
      this.DeviceFaultTypeLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceFaultTypeAnalysis", {
          TimeType: this.searchData.TimeType,
          StartTime: this.searchData.StartTime,
          EndTime: this.searchData.EndTime,
          DeviceTypes: this.searchData.DeviceTypes.join(","),
          Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceFaultTypeLoading = false;
          if (res.Success) {
            this.DeviceFaultType = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },

    //设备全周期故障分布
    async getDeviceFaultYears() {
      this.DeviceFaultYearsLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceFaultYearsAnalysis", {
          // TimeType: this.searchData.TimeType,
          // StartTime: this.searchData.StartTime,
          // EndTime: this.searchData.EndTime,
          // DeviceTypes: this.searchData.DeviceTypes.join(","),
          // Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceFaultYearsLoading = false;
          if (res.Success) {
            this.DeviceFaultYears = res.Data || {};
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //设备故障分析- 寿命期故障分布
    async getDeviceFaultTypeYear() {
      this.DeviceFaultTypeYearLoading = true;
      this.$http
        .post("/PB/PB_Project/GetDeviceFaultTypeYearAnalysis", {
          // TimeType: this.searchData.TimeType,
          // StartTime: this.searchData.StartTime,
          // EndTime: this.searchData.EndTime,
          // DeviceTypes: this.searchData.DeviceTypes.join(","),
          // Buildings: this.searchData.Buildings.join(","),
        })
        .then((res) => {
          this.DeviceFaultTypeYearLoading = false;
          if (res.Success) {
            this.DeviceFaultTypeYear = res.Data || [];
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    //设备寿命分布 楼栋 设备
    getDeviceLifespan() {
      this.DeviceLifespanLoading = true;
      this.$http.post("/PB/PB_Project/GetEquipmentLifespanAnalysis", {}).then((res) => {
        this.DeviceLifespanLoading = false;
        if (res.Success) {
          this.DeviceLifespan = res.Data || {};
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    //设备价值分布 楼栋 设备
    getDeviceValue() {
      this.DeviceValueLoading = true;
      this.$http.post("/PB/PB_Project/GetEquipmentValueAnalysis", {}).then((res) => {
        this.DeviceValueLoading = false;
        if (res.Success) {
          this.DeviceValue = res.Data || {};
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    //设备报废分布 楼栋 设备
    getDeviceScrapping() {
      this.DeviceScrappingLoading = true;
      this.$http.post("/PB/PB_Project/GetEquipmentScrappingAnalysis", {}).then((res) => {
        this.DeviceScrappingLoading = false;
        if (res.Success) {
          this.DeviceScrapping = res.Data || {};
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    //设备区域分布
    getDeviceDistribution() {
      this.DeviceDistributionLoading = true;
      this.$http
        .post("/PB/PB_Project/GetEquipmentDistributionAnalysis", {})
        .then((res) => {
          this.DeviceDistributionLoading = false;
          if (res.Success) {
            this.DeviceDistribution = res.Data || [];
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    getInfoList() {
      // this.getDeviceDistribution();
      // this.getDeviceScrapping();
      // this.getDeviceValue();
      // this.getDeviceLifespan();
      this.getDeviceFaultYears();
      this.getDeviceFaultTypeYear();
    },
    classTypeChange() {
      if (this.searchData.classType == "bui") {
        this.searchData.Buildings = this.BuildingsList.map((item) => item.Id);
      } else if (this.searchData.classType == "dev") {
        this.searchData.DeviceTypes = this.DeviceTypesList.map((item) => item.Id);
      }
    },
    timeTypeChange() {
      if (this.searchData.TimeType === "Year") {
        if (!this.searchData.StartTimeYear || this.searchData.EndTimeYear) {
          this.searchData.StartTimeYear = moment().format("YYYY");
          this.searchData.EndTimeYear = moment().format("YYYY");
        }
      } else if (this.searchData.TimeType === "YearMonth") {
        this.searchData.searchYear = [
          moment().startOf("year").format("YYYYMM"),
          moment().endOf("year").format("YYYYMM"),
        ];
      }
      this.getDataList();
    },
    DeviceTypesListChange(a) {
      console.log(a);
      if (a.length === 1) {
        this.DeviceTypesList.find((item) => item.Id === a[0]).disabled = true;
      } else {
        this.DeviceTypesList.forEach((item) => {
          item.disabled = false;
        });
      }
      this.debouncedGetDataList();
    },
    BuildingsListChange(a) {
      console.log(a);
      if (a.length === 1) {
        this.BuildingsList.find((item) => item.Id === a[0]).disabled = true;
      } else {
        this.BuildingsList.forEach((item) => {
          item.disabled = false;
        });
      }

      this.debouncedGetDataList();
    },
    //获取楼栋列表
    async getBuildingDataList() {
      this.buildingLoading = true;
      await this.$http
        .post("/PB/PB_Project/GetProjectBuildingDataList", {})
        .then((res) => {
          this.buildingLoading = false;
          if (res.Success) {
            this.BuildingsList = res.Data || [];
            this.BuildingsList.forEach((item) => {
              this.$set(item, "disabled", false);
            });
            this.searchData.Buildings = this.BuildingsList.map((item) => item.Id);
          } else {
            this.$notify.error(res.Msg);
          }
        });
    },
    async getProjectDeviceTypeList() {
      this.deviceTypeLoading = true;
      await this.$http.post("/PB/PB_Project/GetDevcieDictionaryMain", {}).then((res) => {
        this.deviceTypeLoading = false;
        if (res.Success) {
          this.DeviceTypesList = res.Data || [];
          this.DeviceTypesList.forEach((item) => {
            this.$set(item, "disabled", false);
          });
          this.searchData.DeviceTypes = this.DeviceTypesList.map((item) => item.Id);
        } else {
          this.$notify.error(res.Msg);
        }
      });
    },
    getDataList() {
      if (this.searchData.TimeType === "Year") {
        this.searchData.StartTime = this.searchData.StartTimeYear;
        this.searchData.EndTime = this.searchData.EndTimeYear;
      } else if (this.searchData.TimeType === "YearMonth") {
        this.searchData.StartTime = this.searchData.searchYear[0];
        this.searchData.EndTime = this.searchData.searchYear[1];
      }
      this.getDeviceFaultDataList();
    },
    //获取所有需要参数的设备故障相关数据
    getDeviceFaultDataList() {
      this.getDeviceFault();
      this.getDeviceStopPower();
      this.getDeviceStopPowerHourType();
      this.getDeviceStopPowerCountType();
      this.getDeviceFaultYearMonth();
      this.getDeviceFaultYearMonthHour();
      this.getDeviceFaultType();
    },
  },
  mounted() {},
  async created() {
    this.searchData.StartTimeYear = moment().format("YYYY");
    this.searchData.EndTimeYear = moment().format("YYYY");
    this.searchData.searchYear = [
      moment().startOf("year").format("YYYYMM"),
      moment().endOf("year").format("YYYYMM"),
    ];

    this.getProjectDeviceTypeList();
    this.getBuildingDataList();

    this.getInfoList();
    this.debouncedGetDataList = this.$tools.debounce(function () {
      this.getDataList();
    }, 500);
  },
  computed: {
    startYearOptions() {
      return {
        disabledDate: (time) => {
          const year = time.getFullYear();
          // 如果结束年份已选择，开始年份需在 [结束年份-10, 结束年份] 范围内
          if (this.searchData.EndTime) {
            const end = parseInt(this.searchData.EndTime);
            return year > end || year < end - 10;
          }
          return false;
        },
      };
    },
    endYearOptions() {
      return {
        disabledDate: (time) => {
          const year = time.getFullYear();
          // 如果开始年份已选择，结束年份需在 [开始年份, 开始年份+10] 范围内
          if (this.searchData.StartTime) {
            const start = parseInt(this.searchData.StartTime);
            return year < start || year > start + 10;
          }
          return false;
        },
      };
    },
  },
  watch: {
    async activeName(nvalue) {
      if (nvalue == "2") {
        this.DeviceFaultLoading = true;
        this.DeviceStopPowerLoading = true;
        this.DeviceStopPowerHourTypeLoading = true;
        this.DeviceStopPowerCountTypeLoading = true;
        this.DeviceFaultYearMonthLoading = true;
        this.DeviceFaultTypeLoading = true;
        this.debouncedGetDataList();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.label {
  font-size: 14px;
  font-weight: bold;
  margin-right: 20px;
  margin-left: 10px;
  display: inline-block;
  width: 100px;
  text-align: right;
}
.search-item {
  display: flex;
  align-items: center;
  margin: 10px 0;
  .el-checkbox-group {
    flex: 1;
  }
}
.yearSelect {
  display: flex;
  align-items: center;
  justify-content: center;

  .separator {
    font-size: 12px;
    margin: 0 10px;
  }
}
.table-card {
  flex: 1;

  text-align: right;
  border-bottom: 1px solid #e4e7ed;
  display: flex;
  align-items: center;
  justify-content: right;
  font-size: 14px;
  font-weight: bold;
}
.Table-List {
  display: flex;

  gap: 15px;
  padding: 10px 0;
}

.class-table {
  width: 100%;
  display: flex;
}
.class-tableItem {
  flex: 1;
  .class-tableItem-title {
    font-size: 14px;
    font-weight: bold;
    height: 40px;
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    align-items: center;
    justify-content: right;
  }
  .class-tableItem-content {
    border-bottom: 1px solid #e4e7ed;
    display: flex;
    align-items: center;
    justify-content: right;
    height: 40px;
    font-size: 12px;
  }
}
::v-deep .el-date-editor {
  .el-input__inner {
    text-align: center;
  }
}
::v-deep .divider {
  height: auto;
}
</style>
